import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1f11ac0c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1f11ac0c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f11ac0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f11ac0c')) {
      api.createRecord('1f11ac0c', component.options)
    } else {
      api.reload('1f11ac0c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1f11ac0c&scoped=true", function () {
      api.rerender('1f11ac0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/componentsTeacher/preview-scratch/index.vue"
export default component.exports